import OSS from 'ali-oss';
import dayjs from '@/utils/dayjs';
import generateTraceId from '@/utils/singUtil/generateTraceId';
import { localRegionMap } from '@/utils/time';
import { useGlobal } from '@/utils/useGlobal';

function useUpload() {
    const { useRouter, getSystemTime } = useGlobal();
    const { locale } = useRouter();
    const curDate = dayjs.tz(getSystemTime(), localRegionMap[locale] || localRegionMap.us);
    const year = curDate.get('year');
    const month = String(curDate.get('month') + 1).padStart(2, '0');
    const day = String(curDate.get('date')).padStart(2, '0');
    const timestamp = getSystemTime();
    const uuid = generateTraceId();
    const HOST_STS = process.env.NEXT_PUBLIC_STS_HOST; // 获取STS地址

    const handleAsyncToOSS = async (file: any, json1: any, json2: any) => {
        // 准备
        const tempArr = file?.name?.split('.');
        const suffix = tempArr[tempArr.length - 1];

        try {
            const { AccessKeyId: accessKeyId, AccessKeySecret: accessKeySecret, SecurityToken: stsToken } = json2;
            const client = new OSS({
                // yourRegion填写Bucket所在地域。以华东1（杭州）为例，yourRegion填写为oss-cn-hangzhou。
                region: json1?.data?.region,
                // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
                accessKeyId,
                accessKeySecret,
                // 从STS服务获取的安全令牌（SecurityToken）。
                stsToken,
                // 填写Bucket名称。
                bucket: json1?.data?.bucket,
            });
            const rrrw = await client.put(`/website/jp-recall/${year}/${month}/${day}/${timestamp}/${uuid}.${suffix}`, file, {
                headers: {
                    // 'x-oss-object-acl': 'private', // 设为私有，不可直接访问
                },
            });
            if (rrrw?.res?.statusCode == 200) {
                return rrrw?.res?.requestUrls[0];
            }
        } catch (e) {
            console.log(e);
        }
    };
    const handlePrepareToOSS = async () => {
        try {
            let json1: any = { data: { region: '', bucket: '', endpoint: '' }, code: '' };
            const result1 = await fetch(`${HOST_STS}/system/oss/fileUpload/prepareSts`, {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            });
            json1 = await result1.json();
            try {
                const result2 = await fetch(`${HOST_STS}/system/oss/fileUpload/stsServer`, {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                });
                const json2 = await result2.json();
                if (json2?.StatusCode === '200') {
                    return { json1, json2 };
                }
            } catch (e) {
                console.log(e);
            }
        } catch (err: any) {
            console.error(err);
        }
    };

    const upload = async (file: File) => {
        try {
            const { json1, json2 }: any = await handlePrepareToOSS();
            return await handleAsyncToOSS(file, json1, json2);
        } catch (error) {
            return null;
        }
    };

    return {
        upload,
    };
}

export default useUpload;
